import { render, staticRenderFns } from "./UserRemoved.vue?vue&type=template&id=119c8e62&scoped=true"
import script from "./UserRemoved.vue?vue&type=script&lang=js"
export * from "./UserRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119c8e62",
  null
  
)

export default component.exports